import { autoinject, computedFrom, observable } from 'aurelia-framework';
import { DialogController } from "aurelia-dialog";
import { DialogService } from 'aurelia-dialog';
import { WebApiService } from "../../services/web-api-service";
import { BusyService } from "../../services/busy-service";
import { PageMessageService } from "../../services/page-message-service";
import { AppMessageService } from "../../services/app-message-service";
import { Insurance } from "../../models/insurance";
import { EventAggregator, Subscription } from 'aurelia-event-aggregator';
import 'jquery';
import 'notify';
import { Carrier } from '../../models/carrier';
import { start } from 'repl';
import { SimpleDialog } from './simple-dialog';
import * as moment from 'moment';

@autoinject
export class UpdateInsuranceDialog {
    savedAuthorityType: any;
    private model: any;
    private isCancelConfirmed: boolean;
    constructor(
        protected controller: DialogController,
        private busyService: BusyService,
        private ea: EventAggregator,
        private appMessageService: AppMessageService,
        private pageMessageService: PageMessageService,
        private dialogService: DialogService,
        private api: WebApiService) {
        this.appMessageService.containerId = "update-insurance-dialog";
    }

    item: Insurance;
    carrier: Carrier;
    nameElement: HTMLElement;
    insuranceTypes: any;
    //endorsements: Array<any> = [];
    existingInsuranceTypeIds: Array<number>;
    authorityTypeLabel: string;

    insuranceTypeChanged() {
        if (!this.item.id) {
            this.loadEndorsements(this.item.insuranceTypeId);
            //this.setEndorsements(this.item);
        }
    }

    canSave: boolean = true;

    activate(model) {

        this.appMessageService.clearPageScopedMessages();

        this.existingInsuranceTypeIds = model.existingInsuranceTypeIds;

        this.carrier = model.carrier;

        this.model = model;
        this.isCancelConfirmed = false;

        //defaults for a new contact
        if (!model.item) {
            this.item = new Insurance();
            this.item.authorityTypeId = model.authorityTypeId;
            this.item.carrierId = model.carrierId;
        } else {
            //create a copy so that the original is not modified until changes are applied
            this.item = JSON.parse(JSON.stringify(model.item));
            this.savedAuthorityType = this.item.authorityTypeId;
        }

        if (this.item.authorityTypeId == "30d0f5ca-81a4-4540-b8a5-cf605bd523e8") {
            this.authorityTypeLabel = "ASSET CARRIER";
        } else if (this.item.authorityTypeId == "ec8d37e1-a1ed-4187-9455-f41b8900088b") {
            this.authorityTypeLabel = "BROKERAGE";
        } else {
            this.appMessageService.addErrorMessage("Please select a valid Authority Type");
        }

        if (!this.carrier.entityType) {
            this.appMessageService.addWarningMessage("The carrier's EntityType must be selected before trying to add an insurance record.", "entity_type");
            this.canSave = false;
        } else {
            this.appMessageService.removeMessageByKey("entity_type");
        }

        this.busyService.on();
        return Promise.all([
            this.loadInsuranceTypes()
        ]).then(() => this.busyService.off());

    }

    attached() {
        this.nameElement.focus();
    }

    loadInsuranceTypes() {
        this.busyService.on();
        return this.api.get("Carriers", "GetInsuranceTypes")
            .then((result) => {
                if (this.item.id) {
                    //existing item (can't change type)
                    this.insuranceTypes = JSON.parse(result.response).filter(o => o.id == this.item.insuranceTypeId);
                } else {
                    //new item (can only choose type that isn't already added)
                    //filter based on entity type
                    this.insuranceTypes = JSON.parse(result.response).filter(o => {
                        return o.entityTypes.indexOf(this.carrier.entityType) > -1
                            && this.existingInsuranceTypeIds.indexOf(o.id) == -1
                    });
                }
            })
            .finally(() => this.busyService.off());
    }

    loadEndorsements(insuranceTypeId: number) {
        return this.api.get("Carriers", "GetCarrierInsuranceEndorsementsByType", { insuranceTypeId: insuranceTypeId })
            .then((result) => {
                this.item.endorsements = JSON.parse(result.response);
                //this.setEndorsements(this.item);
            });
    }

    //setEndorsements(item: Insurance) {
    //item.endorsements = this.endorsements.filter(o => o.insuranceTypeId == item.insuranceTypeId);
    //}

    delete() {

        if (!confirm("Are you sure you want to delete this insurance record?  This cannot be undone."))
            return;

        var params = {
            carrierId: this.item.carrierId,
            id: this.item.id
        };

        this.pageMessageService.clear();
        this.api.post("Carriers", "DeleteCarrierInsurance", params)
            .then(() => {
                $["notify"]("Insurance deleted", { className: "success", position: "top center" });
                this.controller.ok();
            }, () => {
                $["notify"]("Error saving insurance", { className: "error", position: "top center" });
            });
    }

    setEndorsementDate(endorsement) {
        endorsement.endorsementDate = new Date();
    }

    setEndorsementNA(endorsement) {
        endorsement.endorsementChecked = false;
    }

    async save() {

        //var params = {
        //    id: this.item.id,
        //    insuranceTypeId: this.item.insuranceTypeId,
        //    carrierId: this.item.carrierId,
        //    name: this.item.name,
        //    expiration: this.item.expiration,
        //    rating: this.item.rating,
        //    amount: this.item.amount,
        //    umbrellaAmount: this.item.umbrellaAmount,
        //    endorsements: this.item.endorsements
        //};
        var msg = "";

        if (this.item.isCanceled) {


            //  when the value changes to "canceled", confirm that it is intended
            if (!this.model.item.isCanceled && !this.isCancelConfirmed) {
                // only show notice if status isn't already Master Approved Dormant
                if (this.carrier.status != 11) {
                    var model = {
                        title: "Cancel Insurance Cancellation",
                        message: "Cancelling the insurance will set the carrier status to Master Approved - Dormant and will send an email to ALL subscribed CMP users.\n\nDo you want to continue?",
                        showComment: false,
                        buttons: ["Yes", "No"]
                    };

                    var result = await this.dialogService.open(
                        {
                            viewModel: SimpleDialog,
                            model: model
                        })
                        .whenClosed((result) => {
                            if (result.output == "Yes") {
                                this.isCancelConfirmed = true;
                                return true;
                            } else {
                                this.isCancelConfirmed = false;
                                this.item.isCanceled = false;
                                return false;
                            }
                        });

                    if (!result) {
                        return;
                    }
                }
            }

            if (this.item.expiration) {
                var today = new Date();
                var endDate = new Date(this.item.expiration);
                var maxExpiration = new Date();
                maxExpiration.setDate(maxExpiration.getDate() + 30);
                if ((endDate as any) == "Invalid Date") {
                    alert("Invalid Expiration Date: Please enter a valid expiration date, and try again.");
                    return
                }
                if (maxExpiration < endDate) {
                    alert("Insurance expiration cannot be more than 30 days in the future when insurance is marked as canceled.");
                    return;
                }
            } else {
                alert("Insurance expiration must be set when insurance is marked as Canceled");
                return;
            }
        }

        else if (this.item.expiration) {
            var startDate = new Date();
            var endDate = new Date(this.item.expiration);
            if ((endDate as any) == "Invalid Date") {
                alert("Invalid Expiration Date: Please enter a valid expiration date, and try again.");
                return
            }


            var monthsDifference = moment(endDate).diff(moment(startDate), 'months', true);
            if (monthsDifference > 14) {
                msg = "Insurance expiration is more than 14 months in the future.  Click OK to confirm this is correct";
            } else if (startDate > endDate) {
                msg = "Insurance expiration is in the past.  Click OK to confirm this is correct";
            }


            if (msg) {
                var model = {
                    title: "Confirm Insurance Expiration",
                    message: msg,
                    showComment: false,
                    buttons: ["OK", "Cancel"]
                };

                var result = await this.dialogService.open(
                    {
                        viewModel: SimpleDialog,
                        model: model
                    })
                    .whenClosed((result) => {
                        if (result.output == "OK") {
                            return true;
                        }
                    });

                if (!result) {
                    return;
                }
            }
        }



        this.pageMessageService.clear();
        this.item.type = (this.insuranceTypes.find(o => o.id == this.item.insuranceTypeId) || {}).description;

        this.api.post("Carriers", "UpdateCarrierInsurance", this.item)
            .then(() => {
                if (!this.item.id) {
                    $["notify"]("Insurance created", { className: "success", position: "top center" });
                } else {
                    $["notify"]("Insurance updated", { className: "success", position: "top center" });
                }
                this.ea.publish("carrier.insurance.updated", this.item.carrierId);
                if (this.isCancelConfirmed) {
                    this.controller.ok("status_changed");
                } else {
                    this.controller.ok();
                }
            }, () => {
                $["notify"]("Error saving insurance", { className: "error", position: "top center" });
            });

    }

    private monthDiff(d1, d2) {
        let months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        return months <= 0 ? 0 : months;
    }

    private getMonthDifference(startDate, endDate) {
        return (
            endDate.getMonth() -
            startDate.getMonth() +
            12 * (endDate.getFullYear() - startDate.getFullYear())
        );
    }


}